import { EndpointRequest } from "./endpoints.model";
import { AlertThresholdMeasurementType } from "../entities/participant-alert-threshold.model";

/** Matches PatientBiometricThresholdDto from gladstone-data-retriever */
export interface PatientBiometricThresholdDto {
	id?: number;
	participantId?: number;
	biometricType: string;
	biometricSubtype: string;
	thresholdValue: number;
	createdOn?: string;
	updatedOn?: string;
}

/** Subtype strings used when creating/updating participant thresholds (per backend convention) */
export const BIOMETRIC_THRESHOLD_SUBTYPES = {
	BLOOD_PRESSURE_SYSTOLIC_HIGH: "BLOOD_PRESSURE_SYSTOLIC_HIGH",
	BLOOD_PRESSURE_DIASTOLIC_HIGH: "BLOOD_PRESSURE_DIASTOLIC_HIGH",
	BLOOD_PRESSURE_SYSTOLIC_LOW: "BLOOD_PRESSURE_SYSTOLIC_LOW",
	BLOOD_PRESSURE_DIASTOLIC_LOW: "BLOOD_PRESSURE_DIASTOLIC_LOW",
	GLUCOSE_HIGH: "GLUCOSE_HIGH",
	GLUCOSE_LOW: "GLUCOSE_LOW",
} as const;

export interface ParticipantBiometricThresholdsGetRequest extends EndpointRequest {
	participantId: number;
}

/** UI-level update: measurement type + display values. Hook maps to multiple DTOs for backend. */
export interface ParticipantAlertThresholdUpdateBody {
	/** When set, row is custom and we have backend ids to update (one per threshold value) */
	ids?: number[];
	measurementType: AlertThresholdMeasurementType;
	criticallyHigh?: string;
	criticallyLow?: string;
}

export interface ParticipantBiometricThresholdsCreateRequest extends EndpointRequest {
	participantId: number;
	body: PatientBiometricThresholdDto;
}

export interface ParticipantBiometricThresholdsUpdateRequest extends EndpointRequest {
	participantId: number;
	id: number;
	body: PatientBiometricThresholdDto;
}
